import { openUrlOutsideElectron } from './electron-external';

// Used for external navigation that happens via anything other than an anchor tag href
export default function openURL(url: string) {
  if (window.app.isElectron) {
    openUrlOutsideElectron(url);
  } else {
    window.open(url, '_blank');
  }
}
